import { updateRedeemTemplate } from 'actions/redeemTemplates'
import useDispatch from 'hooks/useDispatch'
import { buildTranslate } from 'locales'
import React, { useState } from 'react'

import archiveImg from 'assets/images/redeem-manager/archive.svg'
import ActionModal from './ActionModal'

type Props = {
  templateId: number
  name: string
  isOpen: boolean
  onClose: () => void
  onArchive: () => void
}

const t = buildTranslate('redeem_manager.actions.archive')

const ArchiveModal: React.FC<Props> = ({
  templateId,
  name,
  isOpen,
  onArchive,
  onClose,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const dispatch = useDispatch()

  async function archive() {
    setIsSubmitting(true)
    const result = await dispatch(
      updateRedeemTemplate(templateId, {
        state: 'archived',
      })
    )
    setIsSubmitting(false)

    if (result.error) {
      setError(
        t('error', {
          name,
        })
      )
      return
    }

    onArchive()
  }

  return (
    <ActionModal
      isOpen={isOpen}
      isSubmitting={isSubmitting}
      image={archiveImg}
      title={t('title')}
      headline={t('headline')}
      description={t('description')}
      submitText={t('submit_button')}
      error={error}
      onClose={onClose}
      onSubmit={archive}
    />
  )
}

export default ArchiveModal
